import { css } from "lit-element";
export default css `
h2, .h2 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  font-size: 1.2rem;
}

ol, ul, dl {
  margin-top: 0;
  padding-left: 30px;
}
`;
